import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import ReferralLinksExport from '@/components/v2/ReferralLinksExport';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ActionButton from '@/components/action_button/Index.vue';
import BaseCsvExporter from '@/components/v2/BaseCsvExporter.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import moment from 'moment';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let ReferralLinkExport = class ReferralLinkExport extends Mixins(RouterParamsAppMixin, ViewportSizeMixin, AlertMixin) {
    get labels() {
        const labels = {
            id: 'Link ID',
            name: 'Referral Link Name',
            salesChannel: 'Sales Channel',
            code: 'Referral Link Code',
            dateCreated: 'Date & Time Created',
            clicks: 'Clicks',
            referredOrdersCount: 'Referred Orders',
        };
        return labels;
    }
    get fields() {
        return Object.keys(this.labels);
    }
    get csvName() {
        const timestamp = moment().unix();
        return `${timestamp}_referral_links`;
    }
    alertError(referralLinks) {
        if (!referralLinks || referralLinks.length === 0) {
            this.errorNotification('No data to export');
        }
    }
};
ReferralLinkExport = __decorate([
    Component({
        components: {
            ReferralLinksExport,
            ActionButton,
            BaseCsvExporter,
        },
    })
], ReferralLinkExport);
export default ReferralLinkExport;
